import React, { Component } from 'react'
import { Map , TileLayer, Popup ,ScaleControl, CircleMarker, Polygon} from 'react-leaflet'
import L from 'leaflet'
import {List, Header} from "semantic-ui-react"
import Tinygraph from './tinygraph';

/*
  This compoenent renders the forest map via react-leaflet using OpenStreetMaps.
  This compoenent also displays makers for where the nodes are located, the forest outline as well as a popup graph for that forest.
  The  node locations, forest outline are rednered dynamically using the data passed in from its parnt prop. 
  The component also overlays colors based on the data recieved. 
*/

export default class MapContainer extends Component {
  constructor(props){
    super(props);
    this.state = {
        marker: L.icon({
          iconUrl: require('../assets/elliot.png'),
          iconSize:     [38, 95], // size of the icon
          shadowSize:   [50, 64], // size of the shadow
          iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
          shadowAnchor: [4, 62],  // the same for the shadow
          popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
      }),
      rendering:true

    }
    this.openPopup = this.openPopup.bind(this);
    this.parseBoundry = this.parseBoundry.bind(this)
  }

  openPopup (){
    this.setState({rendering:false}, () =>{
      this.setState({rendering:true})
    })
  }
  componentWillReceiveProps(props){
  }

  parseBoundry(val){
    
    let y = val.split(",0 ").slice(1, -1);
    let fin = []
    y.forEach(item =>{
       let parsedTemp =  item.split(",").map(i =>{
         return parseFloat(i,10)
       })
       fin.push(parsedTemp.reverse())
    })
    return fin;

    
  }

  //redners the nodes as markers.
  renderNodes(){
    let content = [];
    if(this.state.rendering === true){
      if(this.props.nodeInfo){
        let nodeInfo = this.props.nodeInfo;
        // loop through each node info object and push a Merket to the 'content array'
        //return the contet array.
        var self = this;
        Object.keys(nodeInfo).forEach((key) => {
          let position = nodeInfo[key]["lat_lng"];
          let forestNum = nodeInfo[key]["forest_num"]
          let forestName = nodeInfo[key]["forest_name"]
          let nodeNum = nodeInfo[key]["node_num"]
          let vwcState  = 'Normal';
          let forest_boundry = nodeInfo[key]["forest_boundry"];

      
          let searchString = nodeNum;
          function getColor(){
            switch(vwcState){
              case "Dry":
                return "#9b382b";
              case "Normal":
                return "#003f00";
              case "Wet":
                return "#0d3ab1";
              case "Very Wet":
                return "#00ffff";
              default:
                return 'white';
            }
          }
          function getRadius(){
            switch(vwcState){
              case "Dry":
                return 12;
              case "Normal":
                return 9;
              case "Wet":
                return 9;
              case "Very Wet":
                return 12;
              default:
                return 9;
            }
          }
          content.push(
              <div>
                {forest_boundry && <Polygon weight={"1"} onClick={self.openPopup} stfillRule ={'evenodd'} lineJoin = {'round'}color = {getColor()} positions={this.parseBoundry(forest_boundry)} />  }
                <CircleMarker  content={nodeNum} dashArray = {"4 1 2 3"}lineCap={'butt'} color= {'black'} fillColor= {getColor()} fillOpacity= {0.6} center={position} radius ={getRadius()}>
                      <Popup style={{minWidth:'1000'}} onClose={self.openPopup}>
                      {/* N{nodeNum} F{forestNum}<br /> 
                      {fullNodeId}
                      {console.log(self.props)} */}
                        {/* <Visualisations average ={self.props.average}/> */}
                        
                        <Header as='h3' icon='tree' content={forestName} />
                            <List divided  relaxed>
                                <List.Item style={{minWidth:'500px'}}>
                                    <List.Content>
                                    <List.Header>Forest Id</List.Header>
                                    {forestNum} 
                                    </List.Content>
                                </List.Item>
                                <List.Item>
                                    <List.Content>
                                    <List.Header>Node</List.Header>
                                    {nodeNum}
                                    </List.Content>
                                </List.Item>
                                <List.Item>
                                    <List.Content>
                                    <List.Header>Coordinates</List.Header>
                                    {position[0] + ", " + position[1] }
                                    </List.Content>
                                </List.Item>
                                <List.Item>
                                    <List.Content>
                                    <List.Header>VWC Level</List.Header>
                                    {vwcState}
                                    </List.Content>
                                </List.Item>
                            </List>
                            <Tinygraph searchString = {searchString}/>
                      </Popup>
    
                      
                  </CircleMarker>
                  
                </div>
  
          )
        });
      }
    } else{
      content = [];
    }

    // this.setState({rendering:true})
    return content;
  }
  //

  render() {
  const position = [-35.288245, 149.068477]
    return (

      <div className="map">
        <Map animate={true}center={position} zoom={19} className="" style={{height:"900px"}}>
          <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />
          
          {this.state.rendering && this.renderNodes()}
          <ScaleControl/>
        </Map>
      </div>

    )

    }
  }



// WEBPACK FOOTER //
// ./src/components/mapcontainer.js